import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, X, ArrowUp, ArrowDown } from "lucide-react";
import { api } from "../../lib/api";

const inputCls = "w-full border border-line bg-ink px-3 py-2.5 text-sm text-white outline-none transition-colors focus:border-accent";

export default function AdminWorkTypes() {
  const [items, setItems] = useState([]);
  const [newItem, setNewItem] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/work-types").then((r) => setItems(r.data.items || [])).catch(() => toast.error("取得に失敗しました"));
  }, []);

  const save = async (next) => {
    setSaving(true);
    try {
      const r = await api.put("/admin/work-types", { items: next });
      setItems(r.data.items);
      toast.success("保存しました");
    } catch {
      toast.error("保存に失敗しました");
    } finally {
      setSaving(false);
    }
  };

  const add = () => {
    const v = newItem.trim();
    if (!v || items.includes(v)) return;
    save([...items, v]);
    setNewItem("");
  };

  const move = (i, delta) => {
    const j = i + delta;
    if (j < 0 || j >= items.length) return;
    const next = [...items];
    [next[i], next[j]] = [next[j], next[i]];
    save(next);
  };

  return (
    <div data-testid="admin-work-types-page" className="max-w-xl">
      <h1 className="font-mincho text-2xl font-bold text-white">工種マスター</h1>
      <p className="mt-1 font-mono text-[10px] tracking-[0.3em] text-gray-500">WORK TYPES — 作業指示・予定で使う工種の一覧</p>

      <div className="mt-8 flex gap-2">
        <input data-testid="work-type-input" value={newItem} onChange={(e) => setNewItem(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder="例：電気工事" className={inputCls} />
        <button data-testid="work-type-add" onClick={add} disabled={saving || !newItem.trim()} className="flex shrink-0 items-center gap-2 bg-accent px-5 py-2.5 font-display text-xs font-bold tracking-[0.15em] text-ink transition-colors hover:bg-accent-hover disabled:opacity-40">
          <Plus className="h-4 w-4" />
          追加
        </button>
      </div>

      <div className="mt-6 space-y-2">
        {items.map((w, i) => (
          <div key={w} data-testid={`work-type-row-${w}`} className="flex items-center justify-between border border-line bg-panel px-4 py-3">
            <span className="text-sm text-white">{w}</span>
            <div className="flex items-center gap-1">
              <button data-testid={`work-type-up-${w}`} onClick={() => move(i, -1)} disabled={i === 0} className="p-1.5 text-gray-500 transition-colors hover:text-accent disabled:opacity-30"><ArrowUp className="h-4 w-4" /></button>
              <button data-testid={`work-type-down-${w}`} onClick={() => move(i, 1)} disabled={i === items.length - 1} className="p-1.5 text-gray-500 transition-colors hover:text-accent disabled:opacity-30"><ArrowDown className="h-4 w-4" /></button>
              <button data-testid={`work-type-remove-${w}`} onClick={() => save(items.filter((x) => x !== w))} className="p-1.5 text-gray-500 transition-colors hover:text-red-400"><X className="h-4 w-4" /></button>
            </div>
          </div>
        ))}
        {items.length === 0 && <p className="py-6 text-center text-sm text-gray-500">工種が登録されていません。</p>}
      </div>
    </div>
  );
}
